<template>
  <div class="home-layout-wrapper">
    <!-- 顶部导航栏 -->
    <el-header class="home-header">
      <div class="header-content">
        <!-- Logo和标题 -->
        <div class="header-left" @click="goHome">
          <div class="logo-section">
            <img src="@/assets/imgs/logo.png" alt="Logo" class="logo-img">
            <div class="app-title">
              <span class="title-text">供需发布平台</span>
              <span class="title-slogan">连接商机·共创未来</span>
            </div>
          </div>
        </div>

        <!-- 导航菜单 -->
        <div class="header-nav">
          <el-menu
            :default-active="$route.path"
            mode="horizontal"
            router
            background-color="transparent"
            text-color="rgba(255, 255, 255, 0.85)"
            active-text-color="#ffffff"
            class="nav-menu">
            <el-menu-item index="/" class="nav-item">
              <i class="el-icon-s-home"></i>
              <span>首页</span>
            </el-menu-item>
            <el-menu-item index="/supply-demand/list" class="nav-item">
              <i class="el-icon-files"></i>
              <span>供需列表</span>
            </el-menu-item>
            <el-menu-item index="/clue/list" class="nav-item">
              <i class="el-icon-data-analysis"></i>
              <span>供需线索企业SCRM</span>
            </el-menu-item>
            <el-menu-item index="/data-package" class="nav-item">
              <i class="el-icon-box"></i>
              <span>企业数据包</span>
            </el-menu-item>
            <el-menu-item index="/hot" class="nav-item">
              <i class="el-icon-trophy"></i>
              <span>热门推荐</span>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 用户信息 -->
        <div class="header-right" v-if="user && user.id">
          <el-button type="primary" size="small" icon="el-icon-edit" @click="publish" class="publish-btn-header">
            发布信息
          </el-button>
          
          <div class="user-info">
            <div class="avatar-wrapper">
              <el-avatar 
                :size="38" 
                :src="user.avatar"
                class="user-avatar"
                @error="handleAvatarError">
                <img src="https://api.dicebear.com/7.x/bottts/svg?seed=Chloe" />
              </el-avatar>
              <span class="online-badge"></span>
            </div>
            
            <el-dropdown :hide-on-click="false" class="user-dropdown">
              <span class="el-dropdown-link">
                <span class="user-name">{{ user.name || '用户' }}</span>
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                <el-dropdown-item>
                  <div @click="goTo('/personal')" class="dropdown-item">
                    <i class="el-icon-user"></i>
                    <span>个人信息</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goTo('/recharge-package')" class="dropdown-item">
                    <i class="el-icon-wallet"></i>
                    <span>充值中心</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goTo('/center')" class="dropdown-item">
                    <i class="el-icon-setting"></i>
                    <span>账户中心</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goTo('/my-download')" class="dropdown-item">
                    <i class="el-icon-download"></i>
                    <span>我的下载</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goTo('/supply-demand/my')" class="dropdown-item">
                    <i class="el-icon-document"></i>
                    <span>我的供需</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goTo('/favorite/list')" class="dropdown-item">
                    <i class="el-icon-star-off"></i>
                    <span>我的收藏</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item divided>
                  <div @click="exit()" class="dropdown-item exit-item">
                    <i class="el-icon-switch-button"></i>
                    <span>退出登录</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </el-header>

    <!-- 主内容区域 -->
    <el-main class="home-main">
      <router-view/>
    </el-main>

    <!-- 底部 -->
    <el-footer class="home-footer">
      <div class="footer-content">
        <div class="footer-info">
          <p class="footer-text">© 2025 数海领航 供需平台 | 连接供需双方，共创商业机会</p>
          <div class="footer-links">
            <a href="https://www.shuhailinghang.cn/">关于我们</a>
            <span class="divider">|</span>
            <a href="#" @click.prevent="showContactDialog">联系方式</a>
<!--            <span class="divider">|</span>-->
<!--            <a href="#">服务条款</a>-->
<!--            <span class="divider">|</span>-->
<!--            <a href="#">隐私政策</a>-->
          </div>
        </div>
      </div>
    </el-footer>

    <!-- 联系方式弹窗 -->
    <el-dialog
      title="联系我们"
      :visible.sync="contactDialogVisible"
      width="400px"
      center
      class="contact-dialog">
      <div class="contact-content">
        <div class="qrcode-section">
          <img src="@/assets/imgs/customer/customer.png" alt="微信二维码" class="qrcode-img">
        </div>
        <div class="phone-section">
          <span>联系电话：13360926004</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "HomeLayout",
  data() {
    return {
      user: {},
      contactDialogVisible: false
    }
  },
  mounted() {
    let userStr = localStorage.getItem("user");
    if (userStr) {
      this.user = JSON.parse(userStr);
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    goTo(path) {
      this.$router.push(path);
    },
    publish() {
      this.$router.push("/publish");
    },
    exit() {
      localStorage.removeItem("user");
      this.$message({
        message: '退出成功！',
        type: 'success',
        duration: 2000
      });
      this.$router.push("/login");
    },
    showContactDialog() {
      this.contactDialogVisible = true;
    },
    handleAvatarError() {
      // 头像加载失败时的处理
      return true;
    }
  }
}
</script>

<style scoped>
/* ========== 布局容器 ========== */
.home-layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

/* ========== 顶部导航栏 ========== */
.home-header {
  height: 70px !important;
  padding: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
}

/* Logo区域 */
.header-left {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.3s;
}

.logo-section:hover {
  transform: scale(1.02);
}

.logo-img {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.app-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.title-text {
  font-size: 22px;
  font-weight: 700;
  color: white;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title-slogan {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

/* 导航菜单 */
.header-nav {
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: 600px;
}

.nav-menu {
  border: none !important;
  display: flex;
  gap: 10px;
}

.nav-menu ::v-deep .el-menu-item {
  border: none !important;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  transition: all 0.3s;
  font-size: 15px;
  font-weight: 500;
}

.nav-menu ::v-deep .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}

.nav-menu ::v-deep .el-menu-item.is-active {
  background: rgba(255, 255, 255, 0.25) !important;
  font-weight: 600;
}

.nav-item i {
  margin-right: 6px;
  font-size: 16px;
}

/* 用户信息区域 */
.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.publish-btn-header {
  background: white;
  color: #667eea;
  border: none;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 20px;
  transition: all 0.3s;
}

.publish-btn-header:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-wrapper {
  position: relative;
}

.user-avatar {
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
  cursor: pointer;
}

.user-avatar:hover {
  transform: scale(1.08);
  border-color: rgba(255, 255, 255, 0.6);
}

.online-badge {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #52c41a;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(82, 196, 26, 0.6);
}

.user-dropdown {
  cursor: pointer;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s;
  color: white;
}

.el-dropdown-link:hover {
  background: rgba(255, 255, 255, 0.25);
}

.user-name {
  font-size: 14px;
  font-weight: 600;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
}

.dropdown-item i {
  font-size: 16px;
}

.dropdown-item:hover {
  color: #667eea;
}

.exit-item:hover {
  color: #f56c6c;
}

/* ========== 主内容区域 ========== */
.home-main {
  flex: 1;
  padding: 0;
  background: #f5f7fa;
  overflow-y: auto;
}

/* ========== 底部 ========== */
.home-footer {
  height: auto !important;
  padding: 30px 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;
}

.footer-info {
  text-align: center;
}

.footer-text {
  margin: 0 0 15px 0;
  font-size: 14px;
  opacity: 0.9;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  font-size: 13px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s;
}

.footer-links a:hover {
  color: white;
  text-decoration: underline;
}

.footer-links .divider {
  color: rgba(255, 255, 255, 0.4);
}

/* ========== 响应式设计 ========== */
@media (max-width: 1200px) {
  .header-content {
    padding: 0 20px;
  }

  .header-nav {
    max-width: 500px;
  }
}

@media (max-width: 992px) {
  .header-nav {
    display: none;
  }

  .title-slogan {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 15px;
  }

  .logo-img {
    width: 40px;
    height: 40px;
  }

  .title-text {
    font-size: 18px;
  }

  .user-name {
    display: none;
  }

  .publish-btn-header span {
    display: none;
  }

  .footer-links {
    flex-wrap: wrap;
  }
}
</style>

<style>
/* 全局样式 */
.el-dropdown-menu {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #ebeef5 !important;
  padding: 8px !important;
}

.el-dropdown-menu__item {
  border-radius: 8px !important;
  padding: 10px 16px !important;
  margin: 2px 0 !important;
  transition: all 0.3s !important;
}

.el-dropdown-menu__item:hover {
  background: rgba(102, 126, 234, 0.08) !important;
}

/* 联系方式弹窗样式 */
.contact-dialog ::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.contact-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.contact-dialog ::v-deep .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.contact-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.contact-dialog ::v-deep .el-dialog__body {
  padding: 30px;
}

.contact-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.qrcode-section,
.phone-section {
  text-align: center;
}

.qrcode-section h4,
.phone-section h4 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}

.qrcode-img {
  width: 200px;
  height: 273px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
}

.phone-number {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 20px;
  color: #667eea;
  font-weight: 600;
  padding: 15px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 12px;
}

.phone-number i {
  font-size: 24px;
}
</style>
